var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSupport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 4h-1v6a1 1 0 01-1 1H6.828L5 13h5l3 3v-3h2a1 1 0 001-1V5a1 1 0 00-1-1z",
    fill: "#797584"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0h10a1 1 0 011 1v7a1 1 0 01-1 1H6l-3 3V9H1a1 1 0 01-1-1V1a1 1 0 011-1z",
    fill: "#797584"
  })));
}

export default SvgSupport;